export class LaunchpadEvents {
  static errorOccurred = 'launchpad:erroroccurred';
  static urlChanged = 'launchpad:urlchanged';
  static sessionExpired = 'launchpad:sessionexpired';
}